import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PrimaryButton } from "../../../ui/Button/Button";
import { useBuyNowModal } from "./BuyNowModal";

type OrderNowButtonProps = {
  className?: string;
};

export const BuyNowButton: FunctionComponent<OrderNowButtonProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const [, { show }] = useBuyNowModal();

  return (
    <PrimaryButton
      aria-label="openCommerceDialog"
      className={className}
      onClick={show}
      type="button"
    >
      {t("cart.buyNow")}
    </PrimaryButton>
  );
};
